window.shareThis = function (href) {
	let top = (screen.height / 2) - 200;
	let left = (screen.width / 2) - 320;
	window.open(
		href,
		'Share',
		'height=400, width=640, toolbar=no, menubar=no, scrollbars=no, resizable=yes, location=no, directories=no, status=no, top=' + top.toString() + ', left=' + left.toString()
	);
};
